import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4274fb76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "uploadfile_photo"
}
const _hoisted_4 = { class: "left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите количество эскизов", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выберите из списка", -1))
const _hoisted_7 = {
  key: 0,
  class: "uploadfile_photo"
}
const _hoisted_8 = { class: "left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите название страницы эскизного проекта", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: Эскиз вывески с указанием габаритов, материала, цвета RAL", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда файл "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" или нажмите для загрузки")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда файл "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" или нажмите для загрузки")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "filenameSpan" }
const _hoisted_16 = {
  key: 2,
  class: "dots-container"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"dot\" data-v-4274fb76></div><div class=\"dot\" data-v-4274fb76></div><div class=\"dot\" data-v-4274fb76></div><div class=\"dot\" data-v-4274fb76></div><div class=\"dot\" data-v-4274fb76></div>", 5)
const _hoisted_22 = [
  _hoisted_17
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"40px"} }, "Пример изображения"),
  /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/sketch1.png" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Trash = _resolveComponent("Trash")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(_ctx.document.sketch_count)+1, (n) => {
        return (_openBlock(), _createElementBlock("button", {
          key: Number(n+1),
          class: _normalizeClass({activeStep: _ctx.subpage == n}),
          onClick: ($event: any) => {_ctx.prepareFileUpload_click(Number(n));},
          style: {"width":"104px"}
        }, "Шаг " + _toDisplayString(Number(n)), 11, _hoisted_2))
      }), 128))
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _hoisted_6,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.sketch_title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sketch_title) = $event)),
                editable: "",
                options: _ctx.sketch_options,
                optionLabel: "name",
                placeholder: _ctx.sketch_default.name,
                style: {"width":"480px"},
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sketch_change($event)))
              }, null, 8, ["modelValue", "options", "placeholder"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "sketch_multiple_file",
      type: "file",
      hidden: "",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'])))
    }, null, 544),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(_ctx.document.sketch_count)+1, (n) => {
      return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.subpage == n+1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    placeholder: "Введите название страницы эскизного проекта",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.sketch_arr[_ctx.subpage-2]['name']) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.noSubmitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'])))
                  }, null, 544), [
                    [_vModelText, _ctx.document.sketch_arr[_ctx.subpage-2]['name']]
                  ])
                ]),
                (_ctx.document.sketch_arr[_ctx.subpage-2]['file'] != '')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fileUpload",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.sketch_multiple_file.click())),
                      ref_for: true,
                      ref: "fileformuploaded",
                      style: _normalizeStyle('background: url(\'https://api.rekprof.ru/files/'+_ctx.document.sketch_arr[_ctx.subpage-2]['file']+'?a='+_ctx.unicFile+'\'); background-position: center; background-size: contain; background-repeat: no-repeat; border: 1px solid black;')
                    }, _hoisted_12, 4))
                  : _createCommentVNode("", true),
                (_ctx.document.sketch_arr[_ctx.subpage-2]['file'] == '')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "fileUpload",
                      ref_for: true,
                      ref: "fileform",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$refs.sketch_multiple_file.click()))
                    }, _hoisted_14, 512))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.document.sketch_arr[_ctx.subpage-2]['file']==''?'не загружен':_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split("/")[_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split("/").length-1]), 1),
                  (_ctx.document.sketch_arr[_ctx.subpage-2]['file']!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "downloadSpan",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=fileupload&filename=sketch_multiple_file&element='+(_ctx.subpage-2), _ctx.document.sketch_arr[_ctx.subpage-2]['file'].split('/')[_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split('/').length-1]);})
                      }, "Скачать"))
                    : _createCommentVNode("", true),
                  (_ctx.document.sketch_arr[_ctx.subpage-2]['file']!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "delSpan",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'], '1')))
                      }, [
                        _createVNode(_component_Trash)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.proc_upload)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_16, _hoisted_22))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_23
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ], 64))
}